let audioContext = null;

function getAudioContext() {
  if (typeof window === 'undefined') return null;

  if (!audioContext) {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return null;

    audioContext = new AudioContextClass();
  }

  if (audioContext.state === 'suspended') {
    audioContext.resume().catch(() => {});
  }

  return audioContext;
}

function playTone(ctx, frequency, startTime, duration, volume = 0.08, type = 'sine') {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startTime);

  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(volume, startTime + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

  oscillator.connect(gain);
  gain.connect(ctx.destination);

  oscillator.start(startTime);
  oscillator.stop(startTime + duration + 0.02);
}

export function playRewardSound() {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    const now = ctx.currentTime;

    playTone(ctx, 659.25, now, 0.12, 0.07, 'sine');
    playTone(ctx, 783.99, now + 0.09, 0.16, 0.08, 'sine');
  } catch {
    // El sonido nunca debe bloquear la actividad.
  }
}

export function playCelebrationSound() {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    const now = ctx.currentTime;

    // 🎉 Celebración final — aproximadamente 4 segundos
    const melody = [
      [523.25, 0.00, 0.18, 0.08],   // C5
      [659.25, 0.18, 0.18, 0.08],   // E5
      [783.99, 0.36, 0.22, 0.09],   // G5
      [1046.50, 0.58, 0.35, 0.10],  // C6

      [783.99, 1.00, 0.18, 0.08],   // G5
      [1046.50, 1.18, 0.22, 0.09],  // C6
      [1318.51, 1.40, 0.35, 0.10],  // E6

      [1046.50, 1.85, 0.18, 0.08],  // C6
      [1318.51, 2.03, 0.20, 0.09],  // E6
      [1567.98, 2.23, 0.32, 0.10],  // G6

      [1318.51, 2.70, 0.18, 0.08],  // E6
      [1567.98, 2.88, 0.20, 0.09],  // G6
      [2093.00, 3.08, 0.75, 0.12],  // C7 — remate final
    ];

    melody.forEach(([frequency, offset, duration, volume]) => {
      playTone(
        ctx,
        frequency,
        now + offset,
        duration,
        volume,
        'sine'
      );
    });

  } catch {
    // El sonido nunca debe bloquear la actividad.
  }
}
